const actions = {
  GET_STATISTICS_DETAILS_BEGIN: "GET_STATISTICS_DETAILS_BEGIN",
  GET_STATISTICS_DETAILS_SUCCESS: "GET_STATISTICS_DETAILS_SUCCESS",
  GET_STATISTICS_DETAILS_ERR: "GET_STATISTICS_DETAILS_ERR",

  getStatisticsDetailsBegin: () => {
    return {
      type: actions.GET_STATISTICS_DETAILS_BEGIN,
    };
  },

  getStatisticsDetailsSuccess: (data) => {
    return {
      type: actions.GET_STATISTICS_DETAILS_SUCCESS,
      data,
    };
  },

  getStatisticsDetailsErr: (err) => {
    return {
      type: actions.GET_STATISTICS_DETAILS_ERR,
      err,
    };
  },
};

export default actions;
